import { Component, Input } from '@angular/core';
import { ICON_WHITE, BACKGROUND_NONE, BACKGROUND_RED, BACKGROUND_BLUE, ICON_BLUE } from '@app/shared/slider/slider-custom-icon/constants';

@Component({
  selector: 'app-slider-custom-icon',
  templateUrl: './slider-custom-icon.component.html',
  styleUrls: ['./slider-custom-icon.component.css']
})
export class SliderCustomIconComponent {

  @Input() key;
  @Input() iconColor = ICON_WHITE;
  backgroundColor = BACKGROUND_NONE;
  value = 50;

  changeValue(value: number) {
    if (value != null) {
      this.value = value;
      if (value < 50) {
        this.iconColor = ICON_BLUE;
        this.backgroundColor = BACKGROUND_RED;
      } else if (value > 50) {
        this.iconColor = ICON_BLUE;
        this.backgroundColor = BACKGROUND_BLUE;
      } else {
        // this.iconColor = ICON_WHITE;
        this.backgroundColor = BACKGROUND_NONE;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/slider/slider-custom-icon/slider-custom-icon.component.ts